<template>
  <div
    v-if="flightBalanceState.isActive"
    class="positioning"
  >
    <circle-balance-bar
      :positions="positions"
      :is-height-enabled="isHeightEnabled"
      :height-percent="heightPercent"
      style="transform-origin: center bottom"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { flightConfig } from '../app/config/flightConfig'
import {
  CircleBalanceBar,
  WindowAspect
} from '@powerplay/core-minigames-ui'
import { gameConfig } from '@/app/config'
import { flightBalanceState } from '@/stores'

export default defineComponent({
  name: 'FlightBalanceBar',
  components: {
    CircleBalanceBar
  },
  mixins: [WindowAspect],
  data() {

    return {
      flightBalanceState: flightBalanceState(),
    }

  },
  computed: {
    positions() {

      return {
        x: this.positionX,
        y: this.positionY
      }

    },
    positionX() {

      const valX = (flightBalanceState().valueX - flightConfig.originValue) * 0.02
      const valY = (flightBalanceState().valueY - flightConfig.originValue) * 0.02

      const posX = valX * Math.sqrt(1 - Math.pow(valY, 2) / 2) / 2 * 100

      return posX + flightConfig.originValue

    },
    positionY() {

      const valX = (flightBalanceState().valueX - flightConfig.originValue) * 0.02
      const valY = (flightBalanceState().valueY - flightConfig.originValue) * 0.02
      const posY = valY * Math.sqrt(1 - Math.pow(valX, 2) / 2) / 2 * 100

      return 100 - (posY + flightConfig.originValue)

    },
    isHeightEnabled() {

      return gameConfig.heightIndicator.enabled

    },
    heightPercent() {

      const actualHeight = flightBalanceState().actualHeight
      const percent = actualHeight / gameConfig.heightIndicator.fullHeight

      return percent > 1 ? 1 : percent

    }
  }
})
</script>
<style lang="less" scoped>
.positioning {
    position: absolute;
    left: 50%;
    bottom: 1%;
    transform: translate(-50%);
}
</style>
